import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { Notifier } from '../../../shared';
import { AuthRoutes } from '../../../../model';
import { UnauthorizedPage } from '../../../../pages/unauthorized/unauthorized';
import { useSelector } from 'react-redux';
import { RootStoreModel } from '../../../../redux';
import { AuthRoute } from '../../../authRoute/authRoute';
import { Pages, Routes } from '../../../../model/RBAC/constants';

export interface MainProps {
  sideNavAutoCollapse: boolean;
}

export const Main: React.FC<MainProps> = () => {
  const profile = useSelector((state: RootStoreModel) => state.profile && state.profile);

  const getLandingPage = (): string => {
    if (profile.user?.landingPage) {
      const path = Routes.get(Pages[profile.user?.landingPage])?.path;

      if (path !== undefined) return path;
    }
    return Routes[0].path;
  };

  const getRoutes = React.useCallback(() => {
    let routes: JSX.Element[] = [];

    for (let page of Routes.keys()) {
      const routePath = Routes.get(page)?.path;
      routes.push(
        <AuthRoute
          key={routePath}
          path={routePath}
          Component={Routes.get(page)?.component!}
          resource={Routes.get(page)?.resource!}
          userPermission={Routes.get(page)?.userPermission}
        />
      );
    }

    return routes;
  }, []);

  return (
    <>
      <Notifier />
      <Switch>
        <Redirect exact from="/" to={getLandingPage()}></Redirect>
        {getRoutes()}
        <Route path={AuthRoutes.UNAUTHORIZED} component={UnauthorizedPage} />
        <Route path="*">
          <Redirect to={AuthRoutes.NOT_FOUND} />
        </Route>
      </Switch>
    </>
  );
};

export default React.memo(Main);
